import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import { StripeProvider } from 'react-stripe-elements';
import * as Sentry from '@sentry/browser';
import App from './components/App';
import history from './utils/history';
import './utils/i18n';
import '@lightful/ray/dist/css/ray.css';
import './index.scss';

if (process.env.REACT_APP_SENTRY_ENABLED) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENV,
    release: process.env.REACT_APP_VERSION,
  });
}

ReactDOM.render(
  <Router history={history}>
    <StripeProvider apiKey={process.env.REACT_APP_STRIPE_API_KEY}>
      <App />
    </StripeProvider>
  </Router>,
  document.getElementById('root')
);
